// extracted by mini-css-extract-plugin
module.exports = {"circle":"dl1ac","avatarFallback":"_2GWK5","avatar":"_2D16T"};